<template>
  <div id="viewmap">
    <div @click="handleFullScreen" class="fullScreen" @mouseover="showFullScreenIcon()" @mouseout="hideFullScreenIcon()">
      <i class="ivu-icon ivu-icon-md-qr-scanner" style="font-size: 30px;display:none;" id="full-screen-icon"></i>
    </div>
    <div class="demo-carousel" id="view1">
      <div>
        <div style="display: flex">
          <dv-decoration-8 style="width:25%;height:50px;" />
          <h1 class="title" style="flex: 1">储罐实时监控平台</h1>
          <dv-decoration-8 :reverse="true" style="width:25%;height:50px;" />
        </div>
        <dv-decoration-5 style="width: 600px;height: 40px;margin: auto;margin-top: -11px;" />
      </div>
      <Row class="statstcTotal">
        <Col span="1"></Col>
        <Col span="3">
          <dv-border-box-12 style="padding: 8px;">
            <Card :bordered="false">
              <span>今日用气量</span>
              <h4 style="color: #00ffff;">{{obj.todayCurrentDataNm3}}Nm3</h4>
            </Card>
          </dv-border-box-12>
        </Col>
        <Col span="1"></Col>
        <Col span="3">
          <dv-border-box-12 style="padding: 8px;">
            <Card :bordered="false">
              <span>昨日当前用气量</span>
              <h4 style="color: #25d2e8">{{obj.yesterdayDataNm3}}Nm3</h4>
            </Card>
          </dv-border-box-12>
        </Col>
        <Col span="1"></Col>
        <Col span="3">
          <dv-border-box-12 style="padding: 8px;">
            <Card :bordered="false">
              <span>当前同比昨日</span>
              <h4 style="color: #ec4675">
                {{(obj.todayCurrentDataNm3- obj.yesterdayCurrentDataNm3).toFixed(2)}}Nm3
                <Icon
                  type="md-arrow-round-up"
                  v-show="obj.todayCurrentDataNm3- obj.yesterdayCurrentDataNm3>0"/>
                <Icon
                  type="md-arrow-round-down"
                  v-show="obj.todayCurrentDataNm3- obj.yesterdayCurrentDataNm3<0"
                />
              </h4>
            </Card>
          </dv-border-box-12>
        </Col>
        <Col span="1"></Col>
        <Col span="3">
          <dv-border-box-12 style="padding: 8px;">
            <Card :bordered="false">
              <span>当月用气量</span>
              <h4 style="color: #25d2e8">{{obj.monthCurrentDataNm3}}Nm3</h4>
            </Card>
          </dv-border-box-12>
        </Col>
        <Col span="1"></Col>
        <Col span="3">
          <dv-border-box-12 style="padding: 8px;">
            <Card :bordered="false">
              <span style="margin-bottom: 10px;">瞬时流量</span>
<!--              <h4 style="color: #25d2e8">{{obj.lastTotalFlowData}}Nm3</h4>-->
              <dv-digital-flop :config="config" style="height:37px;width: fit-content;margin: auto;margin-bottom: -5px;" />
            </Card>
          </dv-border-box-12>
        </Col>
        <Col span="1"></Col>
        <Col span="2">
          <dv-border-box-12 style="padding: 8px;">
            <Card :bordered="false">
              <span>站点在线率</span>
<!--              <h4 style="color: #25d2e8">{{obj.siteOnlineRate*100}}%</h4>-->
              <dv-decoration-9 style="width:100px;height:100px;color: #25d2e8;font-size: 16px;margin: auto;">{{obj.siteOnlineRate*100}}%</dv-decoration-9>
            </Card>
          </dv-border-box-12>
        </Col>
        <Col span="1"></Col>
      </Row>
      <div>
        <dv-border-box-1>
          <div class="fenkuai" style="padding: 20px;display: flex">
            <div style="width: 25%">
              <Card :bordered="false">
                <div class="line">
                  <h3>大数据统计</h3>
                  <img src="../../assets/line.png"/>
                </div>
                <div class="line">
                  <p>
                    <b style="display: inline-block;width: 70%;font-weight: normal">总用量</b>
                    <span style="color: #fff;font-size: 12px">单位：Nm3</span>
                  </p>
                  <div id="lineEchart"></div>
                  <img src="../../assets/line.png"/>
                </div>
                <!--                <div class="line">-->
                <!--                  <p>数据统计</p>-->
                <!--                  <div id="barEchart"></div>-->
                <!--                  <img src="../../assets/line.png"/>-->
                <!--                </div>-->
                <div class="line">
                  <p>剩余可用时长</p>
                  <dv-scroll-board :config="config1" style="width:100%;height:220px" />
                  <!--                  <ul class="leaveTime">-->
                  <!--                    <li v-for="item in listTime">-->
                  <!--                      <strong>-->
                  <!--                        <i></i>-->
                  <!--                        {{item.siteName.substring(0,2)+"**"}}-->
                  <!--                      </strong>-->
                  <!--                      <b>{{item.haveTime.toString().hlong()}}</b>-->
                  <!--                    </li>-->
                  <!--                  </ul>-->
                </div>
              </Card>
            </div>
            <div style="width: 50%; position: relative;">
              <map-chart ref="mapchart" @clickMap="clickMap" :markData="markData"></map-chart>
            </div>
            <div style="width: 25%">
              <Card :bordered="false">
                <div class="line">
                  <h3>天然气用量数据统计</h3>
                  <img src="../../assets/line.png"/>
                </div>
                <div class="line">
                  <p>
                    <b style="display: inline-block;width: 70%;font-weight: normal">平均天用量</b>
                    <span style="color: #fff;font-size: 12px">单位：Nm3</span>
                  </p>
                  <div id="barEcharts2"></div>
                  <p class="tips">
                    <span>高峰：{{hight}}</span>
                    <span>低谷：{{low}}</span>
                  </p>
                  <img src="../../assets/line.png"/>
                </div>
                <div class="line">
                  <p>站点近7天总用量排行(Nm3)</p>
                  <ul class="leaveTime use">
                    <li v-for="(item,index) in listUse">
                      <strong>
                        <em>{{index+1}}</em>
                        {{item.name.substring(0,2)+'**'}}
                      </strong>
                      <b>{{Number(item.dataNm3).toFixed(2)}}</b>
                    </li>
                  </ul>
                </div>
              </Card>
            </div>
          </div>
        </dv-border-box-1>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    statisticCount,
    currentStatisticCount,
    unusedTime,
    siteAllUsedRank,
    massStatistic,
    averageUseMount,
    getMapInfo,
    siteCount,
    currentMonthData,
    lastTotalFlowData
  } from "@/api/Map.js";
  import {showEcharts} from "@/assets/echartsShow.js";
  import {countTime, howLong} from "../../common/index";
  import mapChart from "../../components/MapChart.vue"

  export default {
    name: "ysy-map",
    components: {
      mapChart
    },
    data() {
      return {
        normal: [],
        exception: [],
        next: true,
        data1: null,
        data2: null,
        data3: null,
        hight: null,
        low: null,
        value1: 0,
        obj: {
          todayCurrentDataNm3: null,
          yesterdayCurrentDataNm3: null,
          yesterdayDataNm3: null,
          siteOnlineRate: null,
          monthCurrentDataNm3: null,
          lastTotalFlowData: null,
        },
        listTime: [],
        listUse: [],
        markData: {normal: [], exception: []},
        companyId: 819,
        fullscreen: false,
        config:{},
        config1:{}
      };
    },
    created: function () {
      //实例被创建之后执行代码
      String.prototype.hlong = function () {
        return howLong(this);
      };
    },
    mounted() {
      let that = this;
      that.$refs.mapchart.initChart(100000, "region");
      if (that.timer) {
        window.clearInterval(that.timer);
      } else {
        that.timer = function () {
          that.getData();
          that.getMonitorData();
          return that.timer;
        };
        setInterval(that.timer(), 10 * 60 * 1000);
      }

      if (that.timer2) {
        window.clearInterval(that.timer2);
      } else {
        that.timer2 = function () {
          that.getLastTotalFlowData();
          return that.timer2;
        };
        setInterval(that.timer2(), 30 * 1000);
      }
    },
    methods: {
      clickMap(data) {
        console.log(data)
      },
      getLastTotalFlowData() {
        lastTotalFlowData({companyId: this.companyId}, res => {
          if (res.data.errcode == 0) {
            let dat = res.data.body;
            this.obj.lastTotalFlowData = parseFloat(parseFloat(dat.flowData).toFixed(2));
            this.config = {
              number: [this.obj.lastTotalFlowData],
              toFixed: 2,
              content: '{nt}Nm3',
              textAlign:'center',
              style: {
                fontSize: 22,
                fill: '#3de7c9'
              }
            }

            console.log(this.config,'kkkkkk')
            this.config = { ...this.config }
          }
        });
      },
      getData() {
        currentStatisticCount({companyId: this.companyId}, res => {
          if (res.data.errcode == 0) {
            let dat = res.data.body;
            //当前数据
            this.obj.todayCurrentDataNm3 = dat.todayCurrentDataNm3;
            this.obj.yesterdayCurrentDataNm3 = dat.yesterdayCurrentDataNm3;
            this.obj.yesterdayDataNm3 = dat.yesterdayCurrentDataNm3;
            this.obj.siteOnlineRate = dat.siteOnlineRate;

          }
        });
        currentMonthData({companyId: this.companyId}, res => {
          if (res.data.errcode == 0) {
            let dat = res.data.body;
            this.obj.monthCurrentDataNm3 = parseFloat(dat.currentDataNm3).toFixed(2);
          }
        });
        // statisticCount(null, res => {
        //   if (res.data.errcode == 0) {
        //     //数据统计
        //     siteCount(null, ret => {
        //       if (ret.data.errcode == 0) {
        //         this.data1 = res.data.body;
        //         this.data1.siteTotalNum += ret.data.body * 1;
        //         showEcharts("barEchart", 2, this.data1);
        //       }
        //     });
        //   }
        // });
        var query = {
          startTime: countTime(7).split(",")[0] + " 00:00",
          endTime: countTime(0).split(",")[1] + " 23:59"
        };
        massStatistic(query, {companyId: this.companyId}, res => {
          if (res.data.errcode == 0) {
            this.data2 = {time: [], value: []};
            res.data.body.dataList.forEach(item => {
              this.data2.time.push(item.collectTime.substring(5));
              this.data2.value.push(item.totalData);
            });
            showEcharts("lineEchart", 1, this.data2);
          }
        });
        siteAllUsedRank(query, {companyId: this.companyId}, res => {
          if (res.data.errcode == 0) {
            this.listUse = res.data.body;
          }
        });
        averageUseMount(query, {companyId: this.companyId}, res => {
          if (res.data.errcode == 0) {
            this.data3 = {time: [], value: []};
            res.data.body.dataList.forEach((item, index) => {
              this.data3.time.push(item.collectTime.substring(5));
              this.data3.value.push(item.totalData);
              if (index == 0) {
                this.hight = item.totalData;
                this.low = item.totalData;
              } else {
                if (parseFloat(this.hight) <= parseFloat(item.totalData)) {
                  this.hight = item.totalData;
                } else if (parseFloat(this.low) > parseFloat(item.totalData)) {
                  this.low = item.totalData;
                }
              }
            });
            showEcharts("barEcharts2", 3, this.data3);
          }
        });
        unusedTime({"pageNumber": 10, companyId: this.companyId}, res => {
          if (res.data.errcode == 0) {
            this.listTime = res.data.body;
            let listTimeNew = []
            this.listTime.forEach(item => {
              listTimeNew.push({
                siteName:'<i class="icon-f"></i>' + item.siteName.substring(0,2)+'**',
                haveTime:item.haveTime.toString().hlong()
              })
            })
            this.config1 = {
              data: listTimeNew,
              align: ['right'],
              rowNum: 7,
              headerBGC: '#1981f6',
              headerHeight: 45,
              oddRowBGC: 'rgba(0, 44, 81, 0.3)',
              evenRowBGC: 'rgba(10, 29, 50, 0.3)'
            }
          }
        });
      },
      //获取监控数据
      getMonitorData() {
        getMapInfo({companyIds: this.companyId}, res => {
          if (res.data.errcode == 0) {
            this.normal = [];
            this.exception = [];
            res.data.body.map(item => {
              if (item.lonlat) {
                if (item.isAlarm == 0) {
                  this.normal.push(item);
                } else {
                  this.exception.push(item);
                }
              }
            });
            this.markData.normal = this.normal.map(item => {
              let coord = item.lonlat.split(",");
              let name = item.siteName;
              let address = item.address;
              let value = item.collectParameterList;
              let id = item.id;
              let adcode = item.adcode;
              return {
                name: name,
                value: coord,
                id: id,
                adcode: adcode
              };
            });

            this.markData.exception = this.exception.map(item => {
              let coord = item.lonlat.split(",");
              let name = item.siteName;
              let address = item.address;
              let value = item.collectParameterList;
              let adcode = item.adcode;
              let id = item.id;
              return {
                name: name,
                value: coord,
                id: id,
                adcode: adcode
              };
            });
          }
        });
      },
      handleFullScreen(){
        let element = document.documentElement;
        // 判断是否已经是全屏
        // 如果是全屏，退出
        if (this.fullscreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
          console.log('已还原！');
        } else {    // 否则，进入全屏
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen();
          }
          console.log('已全屏！');
        }
        // 改变当前全屏状态
        this.fullscreen = !this.fullscreen;
      },
      showFullScreenIcon(){
        document.getElementById("full-screen-icon").setAttribute('style', 'display:block;font-size: 30px')
      },
      hideFullScreenIcon() {
        document.getElementById("full-screen-icon").setAttribute('style', 'display:none;font-size: 30px')
      }
    }
  };
</script>

<style lang="scss">
  body,
  html,
  #app {
    height: 100%;
  }

  #viewmap {
    height: 100%;
    overflow: hidden;
    font-size: 13px;
    color: #fff;
    .dv-scroll-board{
      .rows{
        .row-item{
          line-height: 28px;
          .ceil{
            flex: 1;
            font-size: 13px;
            color: #25d2e8;
            & + .ceil{
              text-align: right;
            }
          }
        }
      }
    }
    .icon-f{
      background: #25d2e8; display: inline-block;display: inline-block;height: 10px;width: 10px;margin-right: 5px;
    }
    .fullScreen {
      position: absolute;
      right: 10px;
      top: 10px;
      width: 30px;
      height: 30px;
      cursor: pointer;
    }
    .title {
      font-size: 20px;
      text-align: center;
      padding-top: 20px;
    }
    .statstcTotal .ivu-card-body {
      padding: 16px 0;
      h4 {
        font-size: 22px;
      }
    }
    .ivu-card {
      background: #0c2962;
      /*box-shadow:0 0 20px #1E5A88 inset;*/
    }
    .ivu-col {
      min-height: 10px;
    }
    .statstcTotal {
      margin: 50px auto 10px;
      .ivu-icon {
        font-size: 12px;
      }
      span {
        display: block;
        text-align: center;
      }
      h4 {
        text-align: center;
        font-size: 20px;
        font-weight: normal;
        margin-top: 10px;
      }
    }
    #lineEchart {
      width: 90%;
      height: 250px;
      margin: 0 auto;
    }
    #barEchart {
      width: 90%;
      height: 150px;
      margin: 0 auto;
    }
    #barEcharts2 {
      width: 90%;
      height: 250px;
      margin: 0 auto;
    }
    .line {
      // min-width: 300px;
      h3 {
        color: #00ffff;
        font-size: 18px;
        padding: 0 20px;
      }

      p {
        color: #00ffff;
        font-size: 15px;
        margin: 5px 0;
      }
      .leaveTime {
        li {
          line-height: 25px;
        }
        strong {
          font-size: 13px;
          color: #25d2e8;
          display: inline-block;
          width: 70%;
          font-weight: normal;
        }
        b {
          font-size: 13px;
          color: #25d2e8;
          display: inline-block;
          width: 28%;
          text-align: right;
          font-weight: normal;
        }
        i {
          width: 8px;
          height: 8px;
          display: inline-block;
          background: #25d2e8;
          margin-right: 2px;
        }
        em {
          padding: 2px 5px;
          display: inline-block;
          background: #fff;
          margin-right: 2px;
          border-radius: 50%;
          color: #333;
          font-size: 11px;
        }
      }
      .use {
        li {
          line-height: normal;
          padding-bottom: 10px;
        }
        strong,
        b {
          color: #fff;
        }
        li:nth-of-type(1) {
          strong,
          b {
            color: #1985e9;
          }
          em {
            background: #1985e9;
          }
        }
        li:nth-of-type(2) {
          strong,
          b {
            color: #8a2cd6;
          }
          em {
            background: #8a2cd6;
          }
        }
        li:nth-of-type(3) {
          strong,
          b {
            color: #26e6b9;
          }
          em {
            background: #26e6b9;
          }
        }
      }
      .tips {
        span {
          display: inline-block;
          font-size: 12px;
          margin: 15px auto 5px;
        }
        span + span {
          margin-left: 20px;
        }
      }
    }
    .fenkuai {
      .ivu-card {
        background: #1b1549;
        /*     opacity: 0.7;*/
      }
    }
    .ivu-carousel {
      height: 100%;
      .ivu-carousel-list {
        height: 100%;
      }
      .ivu-carousel-arrow-hover {
        opacity: 0 !important;
      }
    }
    .ivu-carousel-track,
    .ivu-carousel-item {
      height: 100%;
    }

    .maskDiv {
      width: 100%;
      height: 100vh;
      opacity: 0;
      position: absolute;
    }
    #iframe_add {
      width: 100%;
      height: 100vh;
    }
  }

  #view1 {
    width: 100%;
    height: 100vh;
    background: url("../../assets/bg_new.png") no-repeat;
    background-size: 100% 100%;
  }

  .demo-carousel {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .car2 {
    img {
      height: 100vh !important;
    }
  }

  .ivu-carousel-dots-inside {
    display: none !important;
  }

  @media screen and(max-width: 1366px) {
    #viewmap {
      .title {
        padding-top: 15px;
        padding-left: 10px;
      }
      .line {
        h3 {
          padding: 0px 20px;
        }
        p {
          margin: 0px;
        }
      }
    }
    #viewmap #lineEchart {
      // height: 150px;
      height: 100px;
    }
    #viewmap #barEchart {
      // height: 120px;
      height: 95px;
    }
    #viewmap #barEcharts2 {
      // height: 200px;
      height: 120px;
    }
    .centerItem {
      height: 100%;
      width: 100%;
    }
  }

  /*@media screen and(min-width: 1366px) {*/
  /*  .centerItem {*/
  /*    height: 950px;*/
  /*    width: 950px;*/
  /*  }*/
  /*}*/
</style>
